exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse-item .card-header {\n  cursor: pointer;\n}\n.collapse-item .card-header-icon {\n  transition: transform 0.377s ease;\n}\n.collapse-item .card-content {\n  padding-top: 0;\n  padding-bottom: 0;\n  overflow: hidden;\n}\n.collapse-item .card-content-box {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.collapse-item.is-active > .card-header > .card-header-icon i {\n  transform: rotate(180deg);\n}", ""]);

// exports
